/**
 * isNumber - Returns whether a value is a number
 * @param {unknown} value - A given value
 */
export const isNumber = (value: unknown): boolean =>
  typeof value === 'number' && !Number.isNaN(value)
